<template>
  <div class="policy-page">
    <div class="policy-shell">
      <h1 class="policy-title">{{ title }}</h1>
      <p class="policy-subtitle"></p>

      <div class="policy-frame">
        <iframe
          class="policy-iframe"
          :src="src"
          :title="title"
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PolicyEmbed',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: 'Please review the document below carefully.',
    },
    src: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="less" scoped>
.policy-page {
  padding: 96px 24px 40px;
  box-sizing: border-box;
}

.policy-shell {
  width: 920px;
  max-width: 100%;
  margin: 0 auto;
  text-align: center;
}

.policy-title {
  margin: 0;
  color: #8b7e9e;
  font-size: clamp(28px, 3.8vw, 36px);
  font-weight: 700;
  line-height: 1.3;
}

.policy-subtitle {
  margin: 10px 0 28px;
  color: #a89bb5;
  font-size: 14px;
  line-height: 1.6;
}

.policy-frame {
  overflow: hidden;
  height: 800px;
  min-height: 800px;
  background: #ffffff;
  border: 1px solid #b0a4bc;
  border-radius: 8px;
}

.policy-iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  background: #ffffff;
}

@media screen and (max-width: 750px) {
  .policy-page {
    padding: 80px 16px 32px;
  }

  .policy-subtitle {
    margin-bottom: 20px;
    font-size: 13px;
    padding: 0 8px;
  }

  .policy-frame {
    height: calc(100vh - 250px);
    min-height: 480px;
    border-radius: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PolicyEmbed.vue